import { createRequestActions } from "common/helpers/action";

export const initKkmGroupList = createRequestActions("KKM_GROUP.LIST.INIT");
export const scrollKkmGroupList = createRequestActions("KKM_GROUP.LIST.SCROLL");
